import { Language, Locale, LocalStorageKeys } from 'src/types'
import { TRANSLATIONS } from 'src/constants'

export class LocalService {
  protected currentLocale: Language

  constructor() {
    this.currentLocale =
      (localStorage.getItem(LocalStorageKeys.LOCALE) as Language) || 'en'
  }

  set locale(newLocale: Language) {
    this.currentLocale = newLocale
  }

  get translation(): Locale {
    return TRANSLATIONS[this.currentLocale]
  }
}

export default new LocalService()
